import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import OnboardHelpBox from "./OnboardHelpBox";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardNavigation from "./OnboardNavigation";
import { IRootState } from "../../../store";
import { connect } from "react-redux";
import { History } from "history";
import School from "../../../models/School";
import ApiService from "../../ApiService";

interface OnboardCompletedPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: History;
}

interface OnboardCompletedPageState {
}

class OnboardCompletedPage extends Component<OnboardCompletedPageProps & DispatchProps, OnboardCompletedPageState> {

    constructor(props: OnboardCompletedPageProps & DispatchProps) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<OnboardCompletedPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    private save = async (): Promise<boolean> => {
        return true;
    }

    public render(): JSX.Element {
        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"completed"} />
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className="onboard-timeline-content">
                                    <div className="onboard-timeline-content-center">
                                        Onboarding is Complete!
                                    </div>
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"completed"} timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={false} enableSave={false} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardCompletedPageProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            history: ownProps.history
        };
    }
)(OnboardCompletedPage)